import { render } from "./DriveDetail.vue?vue&type=template&id=18d5118a"
import script from "./DriveDetail.vue?vue&type=script&lang=ts"
export * from "./DriveDetail.vue?vue&type=script&lang=ts"

import "./DriveDetail.vue?vue&type=style&index=0&id=18d5118a&lang=css"
script.render = render

export default script